export const ProjectSettingsNames = {
  RENAME: 'rename',
  ACTIVATE: 'activate',
  DELETE: 'delete',
  DEMO_MODE: 'demo',
} as const;

export const ProjectPlanStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELED: 'canceled',
  PAUSED: 'paused',
  TRIAL: 'trial',
  INCOMPLETE: 'incomplete',
  DRAFT: 'draft',
  PENDING: 'pending',
} as const;

export type ProjectPlanStatusType = (typeof ProjectPlanStatus)[keyof typeof ProjectPlanStatus];
